import React from 'react'
import { Layout } from 'components/Layout'
import { useTranslation } from 'hooks/useTranslation'
import { Footer } from 'components/Footer'
import { Proteins } from 'models/Pet'
import { Header } from 'components/Header'
import { FrozenRecipeRoot } from './FrozenRecipeDetail.styles'
import { CtaFooter } from 'features/Home/components/CtaFooter'
import { RecipeDetailBenefits } from '../FreezeDriedRecipeDetail/components/RecipeDetailBenefits'
import { TranslationKeys } from 'locales/translationKeys'
import { RecipeDetailIngredients } from '../FreezeDriedRecipeDetail/components/RecipeDetailIngredients'
import { HowToOrder } from './components/HowToOrder'
import { ExploreMore } from './components/ExploreMore'
import { RecipeDetailHero } from '../FreezeDriedRecipeDetail/components/RecipeDetailHero'
import { BreadCrumbs } from 'components/BreadCrumbs'
import { BreadCrumbWrapper } from '../FreezeDriedRecipeDetail/FreezeDriedRecipeDetail.styles'
import { frozenRecipes } from './frozenRecipes'

type FrozenRecipeDetailProps = {
  protein: Proteins
}

export const FrozenRecipeDetail = ({ protein }: FrozenRecipeDetailProps) => {
  const { t } = useTranslation()

  const header = <Header />

  const recipe = frozenRecipes[protein]

  const { hero, benefits, ingredients } = recipe

  const crumbs: TranslationKeys[] = ['recipes:frozen-v2.breadcrumb', recipe.breadcrumb]

  return (
    <FrozenRecipeRoot>
      <Layout ctaLabel="recipes:freeze-dried.mobile-cta-label" header={header}>
        <BreadCrumbWrapper>
          <BreadCrumbs crumbs={crumbs} />
        </BreadCrumbWrapper>
        <RecipeDetailHero
          infoList={hero.infoList}
          title={hero.title}
          imageSrc={hero.imageSrc}
          imageAlt={hero.imageAlt}
          features={hero.features}
          description={hero.description}
          nutrition={hero.nutrition}
          proteinPricing={hero.proteinPricing}
          disclaimer1={hero.disclaimer1}
          disclaimer2={hero.disclaimer2}
        />
        <RecipeDetailBenefits
          title={benefits.title}
          imageSrc={benefits.imageSrc}
          imageAlt={benefits.imageAlt}
          list={benefits.list}
        />
        <RecipeDetailIngredients title="recipes:ingredients-title" rows={ingredients} condensed />
        <ExploreMore recipe={protein} />
        <HowToOrder />
        <CtaFooter hideSecondaryCta title="recipes:freeze-dried.footer-cta.title" />
        <Footer />
      </Layout>
    </FrozenRecipeRoot>
  )
}

FrozenRecipeDetail.displayName = 'FrozenRecipeDetail'
